module.exports = __webpack_public_path__ + "img/red-1-oval-open.88efbae2.svg";